import { proxy } from '@/utils'

import render from './render'

export default {
  name: 'DefaultRule',

  mixins: [ proxy({ type: 'object' }) ],

  props: {
    source: String,
    isMultiple: Boolean
  },

  render
}
